import React from "react";

export const DefragInfoCard = ({ details }: { details: string[] }) => {
  return (
    <div className="cw-bg-neutral cw-px-2 cw-py-1 cw-my-2">
      {details.map((detail) => (
        <div className="cw-caption cw-text-muted" key={detail}>
          {detail}
        </div>
      ))}
    </div>
  );
};
